<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img :src="whiteLabel || require('@/assets/images/logo-small-white.png')" alt height="22" />
            </span>
            <span class="logo-lg">
              <img :src="whiteLabel || require('@/assets/images/logo.png')" alt height="17" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img :src="whiteLabel || require('@/assets/images/logo-small-white.png')" alt height="22" />
            </span>
            <span class="logo-lg">
              <img :src="whiteLabel || require('@/assets/images/logo.png')" alt height="52" />
            </span>
          </router-link>
        </div>
      </div>

      <div class="header-title">
        <h3 class="main-color d-flex align-items-center">
          <i class="iconoir-view-grid"></i>
          <span class="ml-2">{{ $t("dashboard.text") }}</span>
        </h3>
      </div>

      <div class="d-flex">
        <b-dropdown class="d-inline-block d-lg-none ml-2" variant="black" menu-class="dropdown-menu-lg p-0" toggle-class="header-item noti-icon" right>
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <navbar-notification />
        <file-manager-progress-widget />

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <div class="d-flex align-items-center gap-4">
              <img v-if="!user.avatar" src="@/assets/images/user.png" alt="User Logo" style="height: 2.875rem;" />
              <img
                v-else
                :src="user.avatar"
                style="border:1px solid gray; width: 2.875rem; height: 2.875rem;"
                class="
                  avatar-title
                  rounded-circle 
                  bg-white
                "
              />

              <span class="d-none d-xl-block user-name">
                {{ user.name }}
              </span>
              <img src="@/assets/images/arrow-down.png" class="d-none d-xl-block" style="width: 0.625rem; flex-shrink: 0;" />
            </div>
          </template>

          <a href="/" class="dropdown-item">
            <i class="bx bxs-dashboard font-size-16 align-middle mr-1"></i>
            {{ $t("dashboard.text") }}
          </a>
          <b-dropdown-divider></b-dropdown-divider>
          <a href="/account" class="dropdown-item">
            <i class="mdi mdi-account font-size-16 align-middle mr-1"></i>
            {{ $t("common.account-profile") }}
          </a>

          <a v-if="isAdminOrOwnerOfAnyWorkpace" href="/workspace" class="dropdown-item">
            <i class="mdi mdi-hexagon-multiple-outline font-size-16 align-middle mr-1"></i>
            {{ $t("workspace.my") }}
          </a>

          <b-dropdown-item @click="go('/management')" v-if="user.type == 'system'">
            <i class="bx bx-fingerprint font-size-16 align-middle mr-1"></i>
            {{ this.$t("pages.go-to-manager-app") }}
          </b-dropdown-item>

          <b-dropdown-item @click="goToPage('/forgot-password')">
            <i class="bx bx-lock font-size-16 align-middle mr-1"></i>
            {{ this.$t("account.change-password") }}
          </b-dropdown-item>
          <!-- item-->

          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logOut()">
            <span class="text-danger">
              <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
              {{ $t("pages.logout") }}
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import FileManagerProgressWidget from "@c/form/file-manager-progress-widget";
import NavbarNotification from "@c/navbar-notification";
import simplebar from "simplebar-vue";

export default {
  components: {
    simplebar,
    NavbarNotification,
    FileManagerProgressWidget,
  },

  computed: {
    userLetterAvatar() {
      const arr = this.user.name?.split(" ");
      const avatar = [];
      for (const [i, value] of arr.entries()) {
        avatar.push(value.charAt(0));
        if (i == 1) {
          break;
        }
      }
      return avatar.join("");
    },
    user() {
      return this.$store.getters["user/account"];
    },
  },
  mounted() {},
  methods: {
    goToPage(page) {
      this.$router.push(page);
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },

    go(path) {
      window.location.href = path;
    },

    async logOut() {
      await this.$store.dispatch("user/logOut");
    },
  },
};
</script>

<style scoped>
.custom-header-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.875rem;
  height: 2.875rem;
  border-radius: 0.625rem;
  border: 1px solid #d0d0d0;
  position: relative;
  transition: background-color, color, 0.3s;
  cursor: pointer;
  background-color: white;
  &:hover {
    background-color: #f5f7f9;
  }
}
</style>
